<div class="input-group mb-3">
    <input type="number" [disabled]="disabled" class="form-control" pattern="/[0-9]+[.,\,]*[0-9]{0,2}/"
        [(ngModel)]="value" (ngModelChange)="onValueChange()">
    <div class="input-group-append">
        <span class="input-group-text">{{ 'units.year' | translate }}</span>
    </div>
</div>